import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Detail from "components/branchDetails/Detail";
import UploadBranchDocument from "components/branchDetails/UploadBranchDocument";

import { getUserProfile } from "services/UserManagementServices";
import { getBranchDetail } from "services/branchServices";

import { getUserRoleFromStorage } from "common/utils/utilities";
import { ROLES } from "common/constants/constants";

import "./branchDetails.scss";
import { useTranslation } from "react-i18next";
const BranchDetails = () => {
  const { t } = useTranslation();
  const [branchData, setBranchData] = useState({});
  const [userProfileData, setUserProfileData] = useState({});
  const [activeTab, setActiveTab] = useState("detail");
  const fetchBranchDetails = async () => {
    let pathIds = {
      branchId: userProfileData?.branchId,
      bankId: userProfileData?.bankId,
      bankgroupsId: userProfileData?.bankGroupId,
    };
    const result = await getBranchDetail(pathIds);
    if (result?.success) {
      setBranchData(result?.payLoad);
    }
  };
  const fetchProfileData = async () => {
    const result = await getUserProfile();
    if (result.success) {
      setUserProfileData(result?.payLoad?.branchInfo);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);
  useEffect(() => {
    if (Object.keys(userProfileData).length > 0) {
      fetchBranchDetails();
    }
  }, [userProfileData]);

  const handleTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="main mt-3">
      <div className="custom-breadcrumbs d-flex py-2 mb-3">
        <div
          className="single-item d-flex align-items-center"
          style={{
            opacity: 0.7,
          }}
        >
          <h5
            className="mb-0 mx-2 text-capitalize"
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/branches");
            }}
          >
            {t("Branch")}
          </h5>
        </div>
      </div>
      <div className="custom-tabs-container">
        <ul className="tabs-nav-custom text-uppercase">
          <li
            className={activeTab === "detail" ? "active" : ""}
            onClick={() => handleTab("detail")}
          >
            {t("details")}
          </li>
        </ul>
        <Detail branchData={branchData} userProfileData={userProfileData} />
      </div>
    </div>
  );
};

export default BranchDetails;
